/* eslint-disable fp/no-mutation */
import { toSeconds } from 'duration-fns';
function transformComparisonV4Response(comparisonResponse, excludePartners) {
    if ((comparisonResponse === null || comparisonResponse === void 0 ? void 0 : comparisonResponse.providers) == null) {
        return [];
    }
    const sourceCurrency = comparisonResponse.sourceCurrency;
    const targetCurrency = comparisonResponse.targetCurrency;
    const sendAmount = comparisonResponse.amount;
    let providers;
    if (excludePartners) {
        providers = comparisonResponse.providers.filter((provider) => isProviderWithQuote(provider) && !provider.partner);
    }
    else {
        providers = comparisonResponse.providers.filter((provider) => isProviderWithQuote(provider));
    }
    return providers
        .map((provider) => transformQuoteFromProvider(sourceCurrency, targetCurrency, sendAmount, provider))
        .sort((a, b) => b.receivedAmount.value - a.receivedAmount.value);
}
function isProviderWithQuote(provider) {
    var _a;
    return ((_a = provider === null || provider === void 0 ? void 0 : provider.quotes) === null || _a === void 0 ? void 0 : _a.length) > 0;
}
function transformQuoteFromProvider(sourceCurrency, targetCurrency, sendAmount, provider) {
    const bestQuote = getBestQuote(provider.quotes);
    return {
        sourceCurrency: sourceCurrency,
        targetCurrency: targetCurrency,
        sendAmount: {
            currency: sourceCurrency,
            value: sendAmount,
        },
        provider: {
            alias: provider.alias,
            name: provider.name,
            logoUrl: provider.logos.normal.pngUrl || '',
            logoCircleUrl: provider.logos.circle.svgUrl || provider.logos.circle.pngUrl || '',
            logoAltText: provider.logos.altText,
            partner: provider.partner,
        },
        markup: bestQuote.markup,
        rate: bestQuote.rate,
        fee: {
            currency: sourceCurrency,
            value: bestQuote.fee,
        },
        receivedAmount: {
            currency: targetCurrency,
            value: bestQuote.receivedAmount,
        },
        deliveryEstimation: Object.assign({}, bestQuote.deliveryEstimation),
    };
}
function getBestQuote(comparisonQuotes) {
    var _a, _b;
    if ((_b = (_a = comparisonQuotes[0]) === null || _a === void 0 ? void 0 : _a.deliveryEstimation) === null || _b === void 0 ? void 0 : _b.providerGivesEstimate) {
        const maximumReceivedAmount = comparisonQuotes.reduce((max, quote) => (quote.receivedAmount > max.receivedAmount ? quote : max), comparisonQuotes[0]).receivedAmount;
        const bestQuotes = comparisonQuotes.filter((quote) => quote.receivedAmount === maximumReceivedAmount);
        const bestQuotesWithSpeed = bestQuotes.filter((quote) => quote.deliveryEstimation.duration !== null);
        const bestQuotesWithSpeedSorted = bestQuotesWithSpeed.sort((a, b) => {
            var _a, _b, _c, _d;
            return toSeconds(((_b = (_a = a.deliveryEstimation) === null || _a === void 0 ? void 0 : _a.duration) === null || _b === void 0 ? void 0 : _b.max) || 0) -
                toSeconds(((_d = (_c = b.deliveryEstimation) === null || _c === void 0 ? void 0 : _c.duration) === null || _d === void 0 ? void 0 : _d.max) || 0);
        });
        return bestQuotesWithSpeedSorted.length > 0 ? bestQuotesWithSpeedSorted[0] : bestQuotes[0];
    }
    return comparisonQuotes.reduce((max, quote) => (quote.receivedAmount > max.receivedAmount ? quote : max), comparisonQuotes[0]);
}
export default transformComparisonV4Response;
